<template lang="pug">
div
  .content-center
    .content-top
      .long-banner-wrap
        .long-banner
          .slider
            .main-banner
              img(src='img/main_banner/banner01.jpg')
            .main-banner
              img(src='img/main_banner/banner01.jpg')
            .main-banner
              img(src='img/main_banner/banner01.jpg')
            .main-banner
              img(src='img/main_banner/banner01.jpg')
            .main-banner
              img(src='img/main_banner/banner01.jpg')
            .main-banner
              img(src='img/main_banner/banner01.jpg')
      //- .tournamentlist-wrap
        .text-uppercase.font-weight-bold.general-title.title-tournament real time status
        .tournamentlist
          .slider
            .d-flex.winner-single
              div
                img(src='img/icon-user.png')
              .text-white.flex-grow-1.winner-detail
                .winner-right
                  .transaction-detail
                    div
                      span.id Ja**0021
                      span.date 2023-01-30 10:00AM
                    div
                      span.status Deposited
                      span.text-deposited.amount RM 30.00
            .d-flex.winner-single
              div
                img(src='img/icon-user.png')
              .text-white.flex-grow-1.winner-detail
                .winner-right
                  .transaction-detail
                    div
                      span.id Ja**0021
                      span.date 2023-01-30 10:00AM
                    div
                      span.status Withdrew
                      span.text-withdrew.amount RM 30.00
            .d-flex.winner-single
              div
                img(src='img/icon-user.png')
              .text-white.flex-grow-1.winner-detail
                .winner-right
                  .transaction-detail
                    div
                      span.id Ja**0021
                      span.date 2023-01-30 10:00AM
                    div
                      span.status Deposited
                      span.text-success.amount RM 30.00
            .d-flex.winner-single
              div
                img(src='img/icon-user.png')
              .text-white.flex-grow-1.winner-detail
                .winner-right
                  .transaction-detail
                    div
                      span.id Ja**0021
                      span.date 2023-01-30 10:00AM
                    div
                      span.status Deposited
                      span.text-success.amount RM 30.00
            .d-flex.winner-single
              div
                img(src='img/icon-user.png')
              .text-white.flex-grow-1.winner-detail
                .winner-right
                  .transaction-detail
                    div
                      span.id Ja**0021
                      span.date 2023-01-30 10:00AM
                    div
                      span.status Deposited
                      span.text-success.amount RM 30.00
            .d-flex.winner-single
              div
                img(src='img/icon-user.png')
              .text-white.flex-grow-1.winner-detail
                .winner-right
                  .transaction-detail
                    div
                      span.id Ja**0021
                      span.date 2023-01-30 10:00AM
                    div
                      span.status Deposited
                      span.text-success.amount RM 30.00
            .d-flex.winner-single
              div
                img(src='img/icon-user.png')
              .text-white.flex-grow-1.winner-detail
                .winner-right
                  .transaction-detail
                    div
                      span.id Ja**0021
                      span.date 2023-01-30 10:00AM
                    div
                      span.status Deposited
                      span.text-success.amount RM 30.00
            .d-flex.winner-single
              div
                img(src='img/icon-user.png')
              .text-white.flex-grow-1.winner-detail
                .winner-right
                  .transaction-detail
                    div
                      span.id Ja**0021
                      span.date 2023-01-30 10:00AM
                    div
                      span.status Deposited
                      span.text-success.amount RM 30.00
            .d-flex.winner-single
              div
                img(src='img/icon-user.png')
              .text-white.flex-grow-1.winner-detail
                .winner-right
                  .transaction-detail
                    div
                      span.id Ja**0021
                      span.date 2023-01-30 10:00AM
                    div
                      span.status Deposited
                      span.text-success.amount RM 30.00
    .announcement-wrapper
      .announcement-content
        .announcement-left
          img.mr-1(src='img/icon-notice.svg')
          | notice
        .announcement-right.flex-grow-1
          marquee(behavior='scroll' direction='left' scrollamount='5') {{$t('ui.notice_welcome')}}
    .slot-wrap(v-if="getKkStatus===true || getNkStatus===true || getLive22Status===true")
      .text-center.mb-3
        .main-title slot games
      .slider-slot
        .slider
          .product-wrap(v-if="getKkStatus===true")
            router-link(to="kingkong")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/kingkong688.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/kingkong688_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'pragmatic', params: {game: 'pragmatic'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/pragmatic-play.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/pragmatic-play-hover.png')
          //- .product-wrap
            a(href='#')
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/jili.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/jili-hover.png')
          .product-wrap(v-if="getLive22Status===true")
            router-link(to="live22")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/live22.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/live22-hover.png')
          //- .product-wrap
          //-   router-link(to="peg")
          //-     .product-single
          //-       .product-pic
          //-         img.w-100.img-fluid(src='img/slot/pegasus.png')
          //-       .product-hover
          //-         img.w-100.img-fluid(src='img/slot/pegasus_hover.png')
          //- .product-wrap
            router-link(to="uuslot")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/uu.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/uu_hover.png')
          //- .product-wrap
            a(href='#')
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/spadegaming.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/spadegaming-hover.png')
          //- .product-wrap
            a(href='#')
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/pg-soft.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/pg-soft-hover.png')
          //- .product-wrap
            a(href='#')
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/jdb.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/jdb-hover.png')
          //- .product-wrap
            a(href='#')
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/skywind.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/skywind-hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'rubyplay', params: {game: 'rubyplay'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/rubyplay.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/rubyplay_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'amatic', params: {game: 'amatic'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/amatic.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/amatic_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'scientificgames', params: {game: 'scientific_games'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/scientific-games.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/scientific-games_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'vegas', params: {game: 'vegas'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/vegas.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/vegas_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'novomatic', params: {game: 'novomatic'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/novomatic.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/novomatic_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'microgaming', params: {game: 'microgaming'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/microgaming.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/microgaming_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'ainsworth', params: {game: 'ainsworth'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/ainsworth.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/ainsworth_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'quickspin', params: {game: 'quickspin'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/quickspin.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/quickspin_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'apollo', params: {game: 'apollo'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/apollo.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/apollo_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'NetEnt', params: {game: 'NetEnt'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/NetEnt.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/NetEnt_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'igt', params: {game: 'igt'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/igt.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/igt_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'aristocrat', params: {game: 'aristocrat'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/aristocrat.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/aristocrat_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'igrosoft', params: {game: 'igrosoft'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/igrosoft.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/igrosoft_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'apex', params: {game: 'apex'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/apex.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/apex_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'gclub', params: {game: 'gclub'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/gclub.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/gclub_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'wazdan', params: {game: 'wazdan'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/wazdan.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/wazdan_hover.png')
          .product-wrap(v-if="getNkStatus===true")
            router-link(:to="{name: 'egt', params: {game: 'egt'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/slot/egt.png')
                .product-hover
                  img.w-100.img-fluid(src='img/slot/egt_hover.png')
    .fish-wrap(v-if="getKkStatus===true || getLive22Status===true")
      .text-center.mb-3
        .main-title {{$t('ui.fishing')}}
      .slider-fish
        .slider
          //- .product-wrap
            router-link(:to="{name: 'fish', params: {game: 'fish'}}")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/fishing/neko-fishing.png')
                .product-hover
                  img.w-100.img-fluid(src='img/fishing/neko-fishing-hover.png')
          .product-wrap(v-if="getLive22Status===true")
            router-link(to="live22fish")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/fishing/live22-fishing.png')
                .product-hover
                  img.w-100.img-fluid(src='img/fishing/live22-fishing-hover.png')
          .product-wrap(v-if="getKkStatus===true")
            router-link(to="kingkongfish")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/fishing/kingkong-fishing.png')
                .product-hover
                  img.w-100.img-fluid(src='img/fishing/kingkong-fishing-hover.png')
    //- .casino-wrap
      .text-center.mb-3
        .main-title casino
      .slider-casino
        .slider
          .product-wrap
            a(href='javascript:void(0)' @click="launchLg()")
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/casino/lg-casino.png')
                .product-hover
                  img.w-100.img-fluid(src='img/casino/lg-casino-hover.png')
          //- .product-wrap
            a(href='#')
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/casino/bg-gaming.png')
                .product-hover
                  img.w-100.img-fluid(src='img/casino/bg-gaming-hover.png')
          //- .product-wrap
            a(href='#')
              .product-single
                .product-pic
                  img.w-100.img-fluid(src='img/casino/dream-gaming.png')
                .product-hover
                  img.w-100.img-fluid(src='img/casino/dream-gaming-hover.png')
    .sport-wrap
      .text-center.mb-3
        .main-title sports
      .sport-content
        template(v-if="!isLoggedIn")
          iframe#frame-highlight.border-0.iframe-highlight(width='100%' :src="wbetUrl + this.getLanguage")
        template(v-else)
          iframe#frame-highlight.border-0.iframe-highlight(width='100%' :src="wbetUrl + this.getLanguage + '&backurl=' + encodeURIComponent(wbetLaunchUrl)")
          //- iframe#frame-highlight.border-0.iframe-highlight(v-if="!wbetDisabled" width='100%' :src="wbetUrl + this.getLanguage + '&backurl=' + encodeURIComponent(wbetLaunchUrl)")
          //- div.pointer(v-else  @click="showError")
            iframe#frame-highlight.border-0.iframe-highlight.pe-none(width='100%' :src="wbetUrl + this.getLanguage")
        //- iframe#frame-highlight.border-0.iframe-highlight(width='100%' src='https://wbetwidget.com/hotmatch?theme=7')
</template>
<script>
import config from '@/config'
export default {
  data(){
    return{
      feedback:{
        success: true,
        status:""
      },
      wbetUrl:"",
      mobileDevice: false,
      wbetLaunchUrl: "",
      wbetDisabled: false,
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "mm"
    },
    getKkStatus(){
			return this.$store.state.user.account.kk
		},
		getLive22Status(){
			return this.$store.state.user.account.live22
		},
		// getLgStatus(){
		// 	return this.$store.state.user.account.lg
		// },
		getNkStatus(){
			return this.$store.state.user.account.nk
		},
  },
  beforeUpdate(){
    $('.slider-slot .slider').filter('.slick-initialized').slick('unslick');
    $('.slider-fish .slider').filter('.slick-initialized').slick('unslick');
  },
  updated(){
    $('.slider-slot .slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: true,	
      rows: 2,
      responsive: [        
        {
        breakpoint: 1200,
        settings: {
          arrows: true,	
          slidesToShow: 2,
          slidesToScroll: 2,	
          autoplay: true,	
          rows: 2,		
          }
        },
              {
        breakpoint: 768,
        settings: {
          arrows: false,  
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          rows: 2,
          autoplay: true,
          }
              },
      ],
    });
    $('.slider-fish .slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: true,	
      rows: 1,
      responsive: [        
        {
        breakpoint: 1200,
        settings: {
          arrows: true,	
          slidesToShow: 2,
          slidesToScroll: 2,	
          autoplay: true,	
          rows: 1,		
          }
        },
              {
        breakpoint: 768,
        settings: {
          arrows: false,  
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          rows: 1,
          autoplay: true,
          }
              },
      ],
    });
  },
  mounted(){
    this.getMobile()
    this.getWbetUrl()
    this.wbetUrl = config.wbetWidget
    $(".long-banner .slider").slick({
      dots: true,
      arrows: false,
      autoplay: true, 
      autoplaySpeed: 3500,		
      infinite: true,
      responsive: [        
        {
        breakpoint: 1600,
        settings: {
          dots: false,
          }
        },	
      ],
    });
    // $(".tournamentlist .slider").slick({
    //   arrows: false,
    //   infinite: true,
    //   slidesToShow: 7,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //       autoplaySpeed: 2500,
    //   vertical: true,
    //   verticalSwiping: true,
    //   responsive: [
    //     {
    //     breakpoint: 1920,
    //     settings: {
    //       slidesToShow: 6,
    //       vertical: true,
    //       verticalSwiping: true,
    //       }
    //     },	
    //     {
    //     breakpoint: 1680,
    //     settings: {
    //       slidesToShow: 5,
    //       vertical: true,
    //       verticalSwiping: true,
    //       }
    //     },	
    //     {
    //     breakpoint: 1500,
    //     settings: {
    //       slidesToShow: 4,
    //       vertical: true,
    //       verticalSwiping: true,
    //       }
    //     },	
    //     {
    //     breakpoint: 1366,
    //     settings: {
    //       slidesToShow: 3,
    //       vertical: true,
    //       verticalSwiping: true,
    //       }
    //     },	
    //     {
    //     breakpoint: 1280,
    //     settings: {
    //       slidesToShow: 2,
    //       vertical: false,
    //       verticalSwiping: false,
    //       }
    //     },	
    //     {
    //     breakpoint: 992,
    //     settings: {
    //       slidesToShow: 2,
    //       vertical: false,
    //       verticalSwiping: false,
    //       }
    //     },	
    //     {
    //     breakpoint: 768,
    //     settings: {
    //       slidesToShow: 1,
    //       vertical: false,
    //       verticalSwiping: false,
    //       }
    //     },
    //   ],
    // });
    $('.slider-fish .slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: true,	
      rows: 1,
      responsive: [        
        {
        breakpoint: 1200,
        settings: {
          arrows: true,	
          slidesToShow: 2,
          slidesToScroll: 2,	
          autoplay: true,	
          rows: 1,		
          }
        },
              {
        breakpoint: 768,
        settings: {
          arrows: false,  
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          rows: 1,
          autoplay: true,
          }
              },
      ],
    });
    $('.slider-casino .slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: true,	
      responsive: [        
        {
        breakpoint: 1200,
        settings: {
          arrows: true,	
          slidesToShow: 2,
          slidesToScroll: 2,
          }
        },
              {
        breakpoint: 768,
        settings: {
          arrows: false,  
          slidesToShow: 2,
          slidesToScroll: 2,
          }
              },
      ],
    });
  },
  methods:{
    showError(){
      var vm =this
      if(this.feedback.status !==""){
        if(this.feedback.status === 'free_credit_detected'){
          this.$swal({
            title: vm.$tc("ui.attention"),
            text: vm.$tc("message.list.free_credit_detected"),
            showCancelButton: true,
            type: "info",
            confirmButtonText: vm.$tc("ui.ok"),
            cancelButtonText: vm.$tc("ui.deposit"),
          }).then(result => {
            if (result.value) {
              vm.$router.push("/slot").catch(error =>{})
            } else if (result.dismiss) {
              if(result.dismiss === 'cancel'){
                vm.$router.push("/deposit").catch(error =>{})
              }
            }
          });
        }else{
          this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + this.feedback.status), "info", this);
        }      
      }else{
        this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.temp_unavailable"), "info", this);
      }     
      this.getWbetUrl()
    },
    getWbetUrl(){
      if (this.sessionToken) {
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let type = (this.mobileDevice ? 2 : 1).toString()
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchWbet", { player_id, auth_token,type, lang_code })
          .then(response => {
            if (response.success == true) {
              this.wbetDisabled = false
							this.wbetLaunchUrl = response.data
            } else {
              if((typeof response.status) != 'object'){
                this.feedback.status = response.status
                this.wbetDisabled = true
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.feedback.status = response.status
            }
            this.wbetDisabled = true
          });
      }else{
				return
			}
    },
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
    launchLg(){
			if (this.sessionToken) {
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let lang_code = "en"
				let mobile = this.mobileDevice
        this.$store
          .dispatch("user/launchLg", { player_id, auth_token, mobile, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							}) 
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				$('#modal-login').modal('show')
			}
		}
  }
}
</script>